import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Inline, Text } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	loadingIndicator: {
		alignItems: 'center',
		flexGrow: 0,
		backgroundColor: token('color.background.neutral.bold'),
		boxShadow: token('elevation.shadow.overlay'),
		borderRadius: token('radius.small'),
		paddingBlockStart: token('space.100'),
		paddingBlockEnd: token('space.100'),
		paddingInlineStart: token('space.100'),
		paddingInlineEnd: token('space.100'),
		marginBlockEnd: token('space.200'),
	},
	loadingContainer: {
		width: '100%',
		position: 'absolute',
		justifyContent: 'center',
		alignItems: 'center',
		bottom: token('space.0'),
	},
});

type LoadingProps = {
	/** Label shown next to the spinner. Defaults to "Loading more". */
	label?: string;
};

export const Loading = ({ label = 'Loading more' }: LoadingProps): React.JSX.Element => (
	<Inline xcss={styles.loadingContainer}>
		<Inline xcss={styles.loadingIndicator} space="space.100">
			<Spinner size="small" appearance="invert" />
			<Text color="color.text.inverse">{label}</Text>
		</Inline>
	</Inline>
);
